import { useMutation } from 'react-query'

import { APIError } from '../../../../../../../../../utils'
import { deleteInvoiceTemplate } from '../query-api'

interface UseDeleteInvoiceTemplateProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useDeleteInvoiceTemplate = (props?: UseDeleteInvoiceTemplateProps) => {
  const { onError, onSuccess } = props || {}
  const { mutate, isLoading: isProcessing, ...rest } = useMutation(deleteInvoiceTemplate, { onSuccess, onError })

  return { delete: mutate, isProcessing, ...rest }
}
